<!-- 
	This is the Dashboards default page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>

    <div>

        <!-- Orders List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">

            <div style="position: absolute; left: 10px; top: 10px; z-index: 10">
                <a-button @click="getData()" class="no-shadow">
                    <a-icon type="reload"></a-icon>
                </a-button>
                <a-button @click="synchronize()" type="primary" class="no-shadow ml-5">
                    Synchronize
                </a-button>
            </div>

            <div style="position: absolute; left: 20px; bottom: 20px; z-index: 10">
                Total Data : <strong>{{ this.formattedData.length }}</strong>
            </div>

            <!-- Table search -->
            <div class="mx-25">
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" class="text-right">
                        <div style="position: relative">
                            <a-input placeholder="input search text" style="max-width: 200px;" v-model="query" allow-clear/>
                            <a-icon v-if="!query" style="position: absolute; right: 10px; top: 12px; color: rgba(0, 0, 0, 0.25)" type="search"></a-icon>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <!-- / Table search -->

            <!-- Orders table -->
            <a-table class="mt-20"
                     :columns="columns"
                     :data-source="formattedData"
                     :pagination="{pageSize: 10}"
                     rowKey="no"
            >

                <template slot="id" slot-scope="no">#{{ no }}</template>

            </a-table>
            <!-- / Orders table -->

        </a-card>
        <!-- / Orders List card -->

    </div>

</template>

<script>

import SettingRepository from "../../../repository/SettingRepository";
import DepartementApi from "../../../repository/api/DepartementApi";
import BookingApi from "../../../repository/api/BookingApi";

// Table columns
const columns = [
    {
        title: 'No',
        dataIndex: 'no',
        sorter: (a, b) => a.no - b.no,
        sortDirections: ['ascend', 'descend'],
        scopedSlots: { customRender: 'id'},
    },
    {
        title: 'Kode',
        sorter: (a, b) => a.id.localeCompare(b.id),
        sortDirections: ['ascend', 'descend'],
        dataIndex: 'id',
    },
    {
        title: 'Nama',
        sorter: (a, b) => a.nama_departemen.localeCompare(b.nama_departemen),
        sortDirections: ['ascend', 'descend'],
        dataIndex: 'nama_departemen',
    },
]

const searchables = [
    'id',
    'nama_departemen',
]

export default {
    data() {
        return {
            columns,
            data: [],
            statusMap: [],

            query: SettingRepository.get("ListKlinik", "filterQuery") ?? '',
        }
    },

    async mounted() {
        this.getData()
    },

    computed: {
        formattedData() {
            return this.data.map((value, index) => ({
                ...value,
                no: index + 1
            })).filter(x => {
                if (!this.query) return true

                for (const col of searchables) {
                    const paths = col.split('.')
                    let val = x

                    for (const path of paths) {
                        val = val[path]

                        if (!val)
                            break
                    }

                    if (val && val.toLowerCase().includes(this.query.toLowerCase()))
                        return true
                }

                return false
            })
        },
    },

    methods: {
        getData() {
            DepartementApi.get()
                .then((response) => {
                    this.data = response
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        synchronize() {
            this.$swal({
                title: "Synchronize",
                text: "Apakah anda yakin ingin sinkronisasi data klinik dengan app DU?",
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: `Batal`,
                icon: 'question',
            }).then((res) => {
                if (res.isConfirmed) {
                    DepartementApi.synchronize()
                        .then((response) => {
                            this.getData()

                            this.$swal({
                                icon: "success",
                                text: "Sinkronisasi berhasil",
                            });
                        })
                        .catch((e) => {
                            this.$swal({
                                icon: e.severity || "error",
                                title: (e.severity || "error").toUpperCase(),
                                text: e.message,
                            })
                        })
                }
            })
        },
    },

    watch: {
        query: function (n, o) {
            SettingRepository.save("ListKlinik", "filterQuery", n)
        },
    }
};
</script>

<style lang="scss" scoped>

</style>
